<template>
    <div :style="{ display: 'flex', flexDirection: direction, alignItems, gap, justifyContent }">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'Stack',
        props: {
            alignItems: {
                type: String,
                default: 'center',
            },
            direction: {
                type: String,
                default: 'column',
            },
            gap: {
                type: String,
                default: undefined,
            },
            justifyContent: {
                type: String,
                default: undefined,
            },
        },
    };
</script>
